import React from "react";
import logo from "../../assets/learning.png";
import "./Header.scss";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

function Header() {
  const { t } = useTranslation();
  
  const mapHeader = [
    { id: 5, name: t("navbar5"), url: "teacher" },
    { id: 4, name: t("yangilipage_r"), url: "news" },
  ];
  const HeaderMap = mapHeader.map((a) => (
    <li key={a.id}>
      <Link to={a.url}>{a.name}</Link>
    </li>
  ));
  return (
    <div className="Header">
      <div className="container">
        <div className="smth">
          <div className="logo">
            <Link to="/">
              <img src={logo} alt="Logo" />
            </Link>
          </div>
          <div className="links">
            <ul>
           
              <li>
                <Link to="/">{t("navbar1")}</Link>
              </li>
              <li>
                <Link to="education">{t("navbar4")}</Link>
              </li>
              {/* <li>
                <a href="/#services">{t("navbar2")}</a>
              </li> */}
              
            
              {HeaderMap}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Header;
